import { getConfigValue } from "../Utils/DataTagConfigurationUtil";

export class ProcessTypeConfigModel {
    Id: number;
    IsShortDescriptionRequired: boolean;
    NeedToDisplayNMTKField: boolean;
    IsSimpleProcess: boolean;
    NeedToInputBetween300And1000SqmResidentalBuildingValue: boolean;
    IsConstructionActivityRequired: boolean;
}

export function GetDefaultConfig(): ProcessTypeConfigModel {
    return {
        Id: -1,
        IsShortDescriptionRequired: false,
        NeedToDisplayNMTKField: false,
        IsSimpleProcess: false,
        NeedToInputBetween300And1000SqmResidentalBuildingValue: false,
        IsConstructionActivityRequired: false
    };
}

export function GetConfigForValue(selectedValue: string): ProcessTypeConfigModel {
    let configForAllProcessTypes = getConfigValue('all-process-types') as ProcessTypeConfigModel[];

    if (!configForAllProcessTypes) {
        return null;
    }

    let selectedValueAsNumber = Number.parseInt(selectedValue);
    let currentConfig: ProcessTypeConfigModel = null;
    
    currentConfig = configForAllProcessTypes.find(e => e.Id == selectedValueAsNumber);

    return currentConfig;
}
